module.exports = __webpack_public_path__ + "static/img/币币交易-banner2.6eb8f0ad.png";